import {
  isNavigationMenuNestedGroup,
  isNavigationMenuNestedLeaf,
  type NavigationMenuGroupChild,
} from "@/components/header/navigationQuery.types";
import { Text } from "@/components/text/text.component";

import { toMobileMenuLink } from "./siteHeaderMobileMenuContent.utils";
import { SiteHeaderMobileMenuLink } from "./siteHeaderMobileMenuLink.component";

export const SiteHeaderMobileMenuColumns = ({
  items,
}: SiteHeaderMobileMenuColumnsProps) => {
  const columns = items.filter(isNavigationMenuNestedGroup);
  const leafItems = items.filter(isNavigationMenuNestedLeaf);

  return (
    <>
      {columns.map((column, index) => (
        <section
          key={column._key}
          data-testid="site-header-mobile-menu-column"
          className={
            index > 0 ? "mt-2 border-t border-black/10 pt-6" : undefined
          }>
          {column.label ? (
            <Text variant="body5" className="text-greyscale-strength mb-2">
              {column.label}
            </Text>
          ) : null}
          <ul className="flex flex-col">
            {(column.items ?? []).map((item) => {
              const link = toMobileMenuLink(item);
              return link ? (
                <SiteHeaderMobileMenuLink key={item._key} item={link} />
              ) : null;
            })}
          </ul>
        </section>
      ))}
      {leafItems.length > 0 ? (
        <ul className="flex flex-col">
          {leafItems.map((item) => {
            const link = toMobileMenuLink(item);
            return link ? (
              <SiteHeaderMobileMenuLink key={item._key} item={link} />
            ) : null;
          })}
        </ul>
      ) : null}
    </>
  );
};

export type SiteHeaderMobileMenuColumnsProps = {
  items: NavigationMenuGroupChild[];
};
